import Vue from 'vue';
import Router from 'vue-router';
import orderProjectRoute from './orderProject';
import agentProjectRoute from './agentProject';
import superMemberProjectRoute from './superMemberProject';
import afterSaleRouter from './afterSale';
import activity from './activity';
import physicalStoreProjectRoute from './physicalStoreProject';
import receiptRouter from './receipt';
import orderPage from './orderPage';
import dataPerformancePage from './dataPerformance'

const _import = require('./_import_' + process.env.NODE_ENV);
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading
Vue.use(Router);
/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    role: ['admin','editor']     will control the page role (you can set multiple roles)
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
    noCache: true                if fasle ,the page will no be cached(default is false)
  }
 **/
export const constantRouterMap = [
  ...orderProjectRoute,
  ...agentProjectRoute,
  ...afterSaleRouter,
  ...superMemberProjectRoute,
  ...activity,
  ...physicalStoreProjectRoute,
  ...receiptRouter,
  ...orderPage,
  ...dataPerformancePage,

  // 基本模块
  {
    path: '/uhome',
    name: 'uhome',
    component: _import('personal/index'),
    hidden: true,
    title: '我的'
  },

  {
    path: '/ucenter/account/info',
    component: _import('personalList/index'),
    hidden: true,
    title: '个人资料列表页'
  },
  {
    path: '/userInfo',
    component: _import('userInfo/index'),
    hidden: true,
    title: '个人基本信息'
  },
  {
    path: '/ucenter/account/info/skin_testing/',
    component: _import('userSkinType/index'),
    hidden: true,
    title: '皮肤类型'
  },
  {
    path: '/inputCodeQuery',
    component: _import('inputCodeQuery/index'),
    hidden: true,
    title: '扫码查询'
  },


  {
    path: '/invitationFans/:type/:agent_level',
    component: _import('invitationFans/index'),
    hidden: true,
    title: '邀请经销商/会员'
  },
  {
    path: '/invitationFans/:type',
    component: _import('invitationFans/index'),
    hidden: true,
    title: '邀请经销商/会员'
  },

  // 商品模块
  {
    path: '/activeCommodities',
    component: _import('activeCommodities/activeCommodities'),
    hidden: true,
    title: '活动商品'
  },
  {
    path: '/redemption',
    name: 'redemption',
    component: _import('redemption/index'),
    hidden: true,
    title: '换购'
  },
  {
    path: '/freeGift',
    name: 'freeGift',
    component: _import('freeGift/index'),
    hidden: true,
    title: '满赠'
  },
  {
    path: '/goodsGroup',
    name: 'goodsGroup',
    component: _import('goodsGroup/index'),
    hidden: true,
    title: '套组'
  },


  // 订单模块
  {
    path: '/changeStore',
    name: 'changeStore',
    component: _import('changeStore/index'),
    hidden: true,
    title: '切换店铺'
  },
  {
    path: '/orderPay',
    name: 'orderPay',
    component: _import('orderPay/index'),
    hidden: true,
    title: '订单支付',
    meta: {
      title: '收银台'
    }
  },
  {
    path: '/allRedemption',
    name: 'allRedemption',
    component: _import('allRedemption/allRedemption'),
    hidden: true,
    meta: {
      title: '全场换购'
    }
  },
  {
    path: '/paynotify',
    component: _import('paySuccess/index'),
    hidden: true,
    title: '支付成功回调页'
  },

  // 公共资源模块
  {
    path: '/invitationCenter',
    component: _import('invitationCenter/index'),
    hidden: true,
    title: '分享中间站'
  },
  // { path: '/pages/agreement', component: _import('register/userAgreement/index'), hidden: true, title: '用户协议' },
  {
    path: '/uhome/agentConstitution',
    component: _import('agentConstitution/index'),
    hidden: true,
    meta: {
      title: '经销商章程'
    }
  },
  {
    path: '/uhome/agentMoneyNotice',
    component: _import('agentMoneyNotice/index'),
    hidden: true,
    meta: {
      title: '保证金说明'
    }
  },

  // 品牌大学模块
  {
    path: '/ucenter/school',
    component: _import('brandUniversity/index'),
    hidden: true,
    title: '品牌大学入口'
  },
  {
    path: '/ucenter/school/train_list/',
    component: _import('trainingCourse/index'),
    hidden: true,
    title: '培训课程'
  },
  {
    path: '/ucenter/school/train_details',
    component: _import('trainingCourseDetail/index'),
    hidden: true,
    title: '课程详情页'
  },

  // 佣金方案
  {
    path: '/commissionScheme',
    name: 'commissionScheme',
    component: _import('commissionScheme/index'),
    hidden: true,
    title: '奖励金说明'
  },
  //游学详情
  {
    path: '/studyTour',
    name: 'studyTour',
    component: _import('studyTour/index'),
    hidden: true,
    title: '活动详情',
    meta: {
      title: '活动详情'
    }
  },
  //英国游学
  {
    path: '/britishStudy',
    name: 'britishStudy',
    component: _import('britishStudy/index'),
    hidden: true,
    title: '活动详情',
    meta: {
      title: '活动详情'
    }
  },
  //年会门票兑换
  {
    path: '/annualPartyTicket',
    name: 'annualPartyTicket',
    component: _import('annualPartyTicket/index'),
    hidden: true,
    meta: {
      title: '英树粉丝狂欢夜'
    }
  },
  //年会门票兑换-规则
  {
    path: '/annualPartyTicket/rule',
    name: 'annualPartyTicket',
    component: _import('annualPartyTicket/rule'),
    hidden: true,
    meta: {
      title: '兑换规则'
    }
  },

  // 换货活动
  {
    path: '/exchangeCenter/activityRules',
    name: 'activityRules',
    component: _import('exchangeCenter/activityRules/index'),
    hidden: true,
    meta: {
      title: '活动规则'
    }
  },


  // 其他

  {
    path: '/superUhome',
    name: 'superUhome',
    component: _import('personal/personalIndex'),
    hidden: true,
    title: '我的英小树'
  },

  // 直播
  {
    path: '/zhibo/agreement',
    name: 'zhibo_agreement',
    component: _import('zhibo/contract/index'),
    hidden: true,
    title: '委托协议',
    meta: {
      title: '委托协议'
    }
  },
  {
    path: '/zhibo/sign',
    name: 'zhibo_sign',
    component: _import('zhibo/sign/index'),
    hidden: true,
    title: '签署协议',
    meta: {
      title: '签署协议'
    }
  },


  // Error模块
  {
    path: '/404',
    component: _import('errorPage/404'),
    hidden: true,
    title: '404'
  },
  {
    path: '/401',
    component: _import('errorPage/401'),
    hidden: true,
    title: '401'
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  },

  // 新政
  // 实名认证
  {
    path: '/certification',
    name: 'Certification',
    component: _import('certification/index'),
    hidden: true,
    title: '实名认证',
    meta: { title: '实名认证' }
  },
];

export default new Router({
  // base: '/dist',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap,
  // mode: 'hash'
  mode: 'history'
});



// export const asyncRouterMap = [];



// WEBPACK FOOTER //
// ./src/router/index.js